import compose from 'lodash/fp/compose';
import React from 'react';

import { withDocumentTitle } from '../../generic/DocumentTitle';
import Titled from '../../layout/Titled';
import { targetSupplierShape } from '../../prop-types';
import api from '../../REST/api';
import withResolved from '../../REST/with-resolved';
import TargetSupplierForm from '../TargetSupplierForm';

const ShowTargetSupplier = ({ model }) => {
  return (
    <Titled title={model.name} sticky>
      <div className="mb-4">
        <TargetSupplierForm model={model} />
      </div>
    </Titled>
  );
};

ShowTargetSupplier.propTypes = {
  model: targetSupplierShape.isRequired,
};

export default compose(
  withResolved({
    query: api.getTargetSupplier,
    deriveQueryArgs: props => ({ id: props.match.params.id }),
    as: 'model',
  }),
  withDocumentTitle(({ model }) => model.name),
)(ShowTargetSupplier);
